export var EPlatformTypes = /*#__PURE__*/function (EPlatformTypes) {
  EPlatformTypes["WebDesktop"] = "webDesktop";
  EPlatformTypes["WebMobile"] = "webMobile";
  return EPlatformTypes;
}({});
export var EPageTypes = /*#__PURE__*/function (EPageTypes) {
  EPageTypes["ValuationNewbuilding"] = "valuationNewbuilding";
  EPageTypes["OfferCard"] = "offerCard";
  EPageTypes["OfferList"] = "offerList";
  EPageTypes["NewbuildingCard"] = "newbuildingCard";
  EPageTypes["NewbuildingList"] = "newbuildingList";
  EPageTypes["NewbuildingBlockOfferList"] = "newbuildingBlockOfferList";
  EPageTypes["NewbuildingDeveloperSite"] = "siteDeveloper";
  EPageTypes["Map"] = "map";
  EPageTypes["OfferComparison"] = "offerComparison";
  EPageTypes["NewbuildingReviews"] = "newbuildingReviews";
  EPageTypes["DiscountDay"] = "discountDay";
  EPageTypes["NewbuildingPromos"] = "newbuildingPromos";
  return EPageTypes;
}({});